module.exports = __webpack_public_path__ + "img/receive-your-results.fe422a5b.jpg";